var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.show)?_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","name":"myFrameName","id":"myFrameId"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }